import Rate from './Rate';
export default Rate;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-rate@2.4.2@rc-rate/es/index.js
// module id = 733
// module chunks = 0